import { createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import { removeSharedCookie } from "../config/cookiesSettings";
import { normalizeAccessList } from "../utils/access";
export const currentUserSlice = createSlice({
    name: "current_user",
    initialState: {
        user: {},
        apiKeyStatus: "pending",
        isLoading: false,
        loadError: "",
    },
    reducers: {
        updateCurrentUser: (state, action) => {
            let new_user = action.payload;
            new_user = { ...new_user, access_list: normalizeAccessList(new_user.access_list) };
            return {
                ...state,
                user: new_user,
                apiKeyStatus: "validated",
            };
        },
        updateLoadingStage: (state, action) => {
            return {
                ...state,
                isLoading: action.payload,
            };
        },
        updateLoadError: (state, action) => {
            let new_user = state.user;
            if(!action.payload.timedout){
                let cookies = new Cookies();
                removeSharedCookie(cookies, "api_key");
                removeSharedCookie(cookies, "team_id");
                new_user = {}
            }
            return {
                ...state,
                loadError: action.payload.error_message,
                apiKeyStatus: "failed",
                user: new_user,
            };
        },
        userLogOut: (state) => {
            return {
                ...state,
                user: {},
                apiKeyStatus: "missing",
            };
        },
    },
});

export const {
    updateCurrentUser,
    userLogOut,
    updateLoadingStage,
    updateLoadError,
} = currentUserSlice.actions;

export default currentUserSlice.reducer;
